import basicReducer from './basic-reducer';
import selectionReducer from './selection-reducer';
import aggregatedRowReducer from './aggregated-row-reducer';

export const defaultReducers = [
  basicReducer,
  selectionReducer,
];

export const extendReducers = {
  aggregatedRowReducer,
};

export { combineReducers } from './combine-reducers';
